var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBookOpen = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3.85 6.73v11.117c1.084-.448 2.333-.697 3.65-.697s2.566.25 3.65.697V6.73c-.974-.54-2.242-.88-3.65-.88s-2.676.34-3.65.88m9 0v11.117c1.084-.448 2.333-.697 3.65-.697s2.566.25 3.65.697V6.73c-.974-.54-2.242-.88-3.65-.88s-2.676.34-3.65.88M12 5.258C10.745 4.555 9.177 4.15 7.5 4.15c-1.894 0-3.647.516-4.97 1.395a.85.85 0 0 0-.38.708v13a.85.85 0 0 0 1.32.708c1.013-.673 2.431-1.111 4.03-1.111s3.017.438 4.03 1.11a.85.85 0 0 0 .94 0c1.013-.672 2.431-1.11 4.03-1.11s3.017.438 4.03 1.11a.85.85 0 0 0 1.32-.707v-13a.85.85 0 0 0-.38-.708c-1.322-.88-3.076-1.395-4.97-1.395-1.677 0-3.245.405-4.5 1.108",
  clipRule: "evenodd"
})));
export default SvgBookOpen;